<template>
<div class="DeviceDatasContainer">
  <div class="nowData commonCons">
    <div class="cons">
      <h3>实时数据</h3>
      <span class="rightUpdate" @click="updateData" :style="styleObj">
        <i><img src="../../../assets/img/deviceGas/nowDataUpdate.png" alt=""></i>
        <b>{{changeFlag?'关闭实时更新':'开启实时更新'}}</b>
      </span>
    </div>
    <div class="cardBanner">
      <el-carousel :interval="4000" type="card" height="110px" :autoplay="false">
        <el-carousel-item v-for="(item,index) in datailsData" :class="(activeIndex==index)?'active':''" @click.native="cardClick(item,index)" :key="index">
          <div class="cardTit">
            <a href="#">
              <p class="p1">{{item.name}}</p>
              <p class="p2">{{item.value}}{{item.unit}}</p>
            </a>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="noData" v-if="!(datailsData&&datailsData.length)">
        <span>暂无数据</span>
      </div>
    </div>
  </div>
  <div class="hositoryData commonCons">
    <div class="cons">
      <h3>历史数据</h3>
    </div>
    <div class="tabChangs">
      <ul>
        <li :style="styleObj1" @click="changeList" :class="{active:num==0}">列表展示</li>
        <li :style="styleObj1" @click="changeEcharts" :class="{active:num==1}">曲线展示</li>
      </ul>
    </div>
    <div class="listCons" v-show="num==0">
      <div class="query">
        <span class="qCons">
          <el-date-picker :disabled="!(this.datailsData&&this.datailsData.length)" v-model="creatTime" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"></el-date-picker>
          <!-- <el-input placeholder="请输入字段名称" v-model="searchText" style="width:170px;"></el-input> -->
          <button :style="styleObj" class="primaryBtn" v-if="rolePermit('device:gas:query')" @click="searchData">查询</button>
        </span>
        <span class="qTit">
          <i><img src="../../../assets/img/deviceGas/nowDataTime.png" alt=""></i>
          <b>最新数据更新时间：{{datetime?datetime:'暂无'}}</b>
        </span>
      </div>
      <div class="dataCons" :style="styleObject">
        <border-table v-if="dataList&&dataList.length" :tableData="dataList" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading" :current-page="pagination.page" @currentChange="gasCurrentChange" @sizeChange="gasSizeChange">
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="" label="设备属性名称" :show-overflow-tooltip="true">{{deviceDatas.name}}</el-table-column>
          <el-table-column prop="value" :label="deviceDatas.name +'值'" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ scope.row.value }}{{ deviceDatas.unit }}
            </template>
          </el-table-column>
          <el-table-column prop="datetime" label="更新时间" :show-overflow-tooltip="true"></el-table-column>
        </border-table>
        <div class="noData" v-if="!(dataList&&dataList.length)&&consShow">
          <img src="../../../assets/img/noData.png" alt="">
          <div class="tip">暂无数据</div>
        </div>
      </div>
    </div>
    <div class="echartsShow" v-if="num==1">
      <div class="queryLists">
        <div class="left query">
          <el-date-picker v-model="echartsTime" :picker-options="pickerOptionsDate" type="date" placeholder="选择日期"></el-date-picker>
          <button class="primaryBtn" v-if="rolePermit('device:gas:query')" @click="searchDataeCharts">查询</button>
        </div>
        <div class="right">
          <ul>
            <li v-for="(item,index) in dateLists" :class="(echartsIndex==index)?'active':''" :key="index" @click="getHository(item,index)">
              <span>{{item.label}}</span>
            </li>
          </ul>
        </div>
      </div>
      <echarts :style="styleObject1" ref="chartLine" v-loading="chartLoading" chart-id="chartLineId" :chart-option="options"></echarts>
    </div>
  </div>
</div>
</template>

<script>
import * as echarts from 'echarts'
import BorderTable from "@/views/deviceManagement/deviceDetails/BorderTableNew";
export default {
  components: {
    BorderTable
  },
  props: {
    deviceChildId: {
      type: Number,
      default: () => {
        return null;
      }
    },
    typeChild:{
      type: String,
      default: () => {
        return null;
      }
    }
  },
  data() {
    return {
      pickerOptionsDate:{
        disabledDate(time) {
          // 禁止选择本日之后
          return (time.getTime() > Date.now()) || ((time.getTime() + 3600 * 1000 * 24 * 30) < Date.now());
        },
      },
      echartsIndex:0,
      echartsTime:'',
      quickTime:0,
      dateLists:[
        {
          label:'一天',
          value:0
        },
        {
          label:'一周',
          value:1
        },
        {
          label:'一个月',
          value:2
        }
      ],
      options: {
        graphic: [{
          type: 'group',
          left: 'center',
          top: 'center',
          children: [{
            type: 'text',
            z: 100,
            left: 'center',
            top: 'middle',
            style: {
              fill: '#333',
              text: [''].join('\n'),
              font: '14px'
            }
          }]
        }],
        color: '#1089FF',
        // backgroundColor: '#0e1c47',
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          axisPointer: {
            lineStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(126,199,255,0)' // 0% 处的颜色
                }, {
                  offset: 0.5,
                  color: 'rgba(126,199,255,1)' // 100% 处的颜色
                }, {
                  offset: 1,
                  color: 'rgba(126,199,255,0)' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              }
            }
          }
        },
        grid: {
          top: '5%',
          left: '5%',
          right: '5%',
          bottom: '8%'
          // containLabel: true
        },
        xAxis: [{
          name: '日期',
          type: 'category',
          boundaryGap: true,
          axisLine: { // 坐标轴轴线相关设置。数学上的x轴
            show: true,
            lineStyle: {
              // color: '#1089FF'
              color: 'rgba(16,137,255,0.1)'
            }
          },
          axisLabel: { // 坐标轴刻度标签的相关设置
            textStyle: {
              color: '#999B9E',
              padding: 0,
              fontSize: 12
            },
            formatter: function(data) {
              return data
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#192a4411'
            }
          },
          axisTick: {
            show: false
          },
          data: []
        }],
        yAxis: [{
          name: '',
          nameTextStyle: {
            color: '#999B9E',
            fontSize: 12,
            padding: 0
          },
          min: 0,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#192a4411'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              // color: '#23365311'
              color: 'rgba(16,137,255,0.1)'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#999B9E',
              padding: 0
            },
            formatter: function(value) {
              if (value === 0) {
                return value
              }
              return value
            }
          },
          axisTick: {
            // show: false
            alignWithLabel: true
          }
        }],
        series: [{
          name: '报警次数:',
          type: 'line',
          smooth: true,
          // showSymbol: false,
          symbolSize: 7,
          zlevel: 3,
          lineStyle: {
            normal: {
              color: '#1089FF',
              shadowBlur: 3,
              shadowColor: '#14b1eb66',
              shadowOffsetY: 0
            }
          },
          // markPoint: {
          //   label: {
          //     normal: {
          //       textStyle: {
          //         color: '#fff'
          //       }
          //     }
          //   },
          //   data: [{
          //     type: 'max',
          //     name: '最大值'
          //   }, {
          //     type: 'min',
          //     name: '最小值'
          //   }]
          // },
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [{
                  offset: 0,
                  color: '#1089FF'
                },
                {
                  offset: 1,
                  color: '#14b1eb00'
                }],
                false
              ),
              shadowColor: '#14b1eb11',
              shadowBlur: 10
            }
          },
          data: []
        }]
      },
      fbdate: null,
      fedate: null,
      creatTime: [],
      pickerOptions: {
        shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      searchText: '',
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      tableLoading: false,
      dataList: [],
      deviceTypeList: [],
      datailsData: [],
      num:0,
      activeIndex:0,
      chart:'',
      chartLoading:false,
      styleObject:{
        height:''
      },
      styleObject1:{
        height:''
      },
      deviceDatas:{},
      dataChartsList: [],
      consShow:false,
      datetime:'',
      timer: null,
      changeFlag:false,
      styleObj:{},
      styleObj1:{}
    }
  },
  created() {
    this.makeheight()
    this.makeheight1()
    let nowTime = new Date()
    let lastTime = new Date(nowTime.getTime() - 3600 * 1000 * 24 * 30)
    this.creatTime = [lastTime, nowTime]
    this.detailDatas()
  },
  methods: {
    changeList(){
      if(!(this.datailsData&&this.datailsData.length)){
        return
      }
      this.num = 0
      this.reloadTable()
    },
    changeEcharts(){
      if(!(this.datailsData&&this.datailsData.length)){
        return
      }
      this.num = 1
      this.getHositoryEchart()
    },
    cardClick(data,index) {
      // console.log(data);
      this.deviceDatas=data
      this.activeIndex=index
      this.datetime=data.datetime
      if(this.num){
        if(!this.echartsTime){
          this.quickTime = 0
          this.echartsIndex = 0
        }
        this.getHositoryEchart()
      }else{
        this.reloadTable()
      }
    },
    detailDatas() { //设备实时数据
      // this.datailsData=[]
      this.consShow=false
      this.request.get("/front/device/gateway/child/" + this.deviceChildId+'/value').then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.styleObj={
            'background':!(JSON.stringify(res.data)!='{}')?'#ccc':'',
            'cursor':!(JSON.stringify(res.data)!='{}')?'not-allowed':'pointer'
          }
          this.styleObj1={
            'cursor':!(JSON.stringify(res.data)!='{}')?'not-allowed':'pointer'
          }
          if(JSON.stringify(res.data)!='{}'){
            let nowDatas = res.data
            this.datailsData = [
              {
                name:this.typeChild=='CH4'?'甲烷':this.typeChild=='NH3'?'氨气':this.typeChild=='H2S'?'硫化氢':this.typeChild=='CO'?'一氧化碳':this.typeChild=='Temperature'?'温度':this.typeChild=='Humidity'?'湿度':this.typeChild=='Vlotage'?'电压':this.typeChild=='Relay'?'继电器':this.typeChild=='PID'?'PID':this.typeChild,
                value:nowDatas.value,
                datetime:nowDatas.dateTime
              }
            ]
            this.deviceDatas=this.datailsData[this.activeIndex]
            this.datetime=nowDatas.dateTime
            if(this.num){
              this.getHositoryEchart()
            }else{
              this.reloadTable()
            }
          } else {
            this.consShow=true
          }
          // console.log(this.datailsData);
        } else if (res.code === 500) {
          this.msg.warn(res.msg)
        }
      })
    },
    searchData() {
      if(!this.creatTime||this.creatTime.length<1){
        this.msg.warn('请您选择日期！')
        return
      }
      if(!(this.datailsData&&this.datailsData.length)){
        return
      }
      //查询//查询
      this.searchText = this.searchText.replace(/(^\s*)|(\s*$)/g, "")
      this.pagination.currentPage = 1;
      this.reloadTable();
    },
    gasCurrentChange(val) {
      this.pagination.currentPage = val;
      this.reloadTable();
    },
    //表格展示条数变化时
    gasSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.reloadTable();
    },
    getCurrentYear() {
      this.consShow=false
      // console.log(this.creatTime);
      if (this.creatTime != null && this.creatTime.length) {
        let date = new Date();
        let y = date.getFullYear();

        let date0 = this.creatTime[0];
        let y0 = date0.getFullYear();

        let date1 = this.creatTime[1];
        let y1 = date1.getFullYear();

        let date2 = this.creatTime[0];
        let y2 = this.formatDate(date2)
        let data3 = this.formatterDate(this.storage.getSession("sysStartTime"));
        let y3 = this.formatDate(data3)

        if (y0 > y) {
          this.msg.error('输入开始日期年份大于当前年份，请重新输入！')
        } else if (y1 > y) {
          this.msg.error('输入结束日期年份大于当前年份，请重新输入！')
        } else if (y3 > y2) {
          this.msg.error('选择时间小于系统开始时间，请重新输入！')
        } else {
          this.tableLoading = true
          this.fbdate = this.formatDate(this.creatTime[0]);
          this.fedate = this.formatDate(this.creatTime[1]);
          this.params = {
            "key": this.searchText,
            "startTime": this.fbdate,
            "endTime": this.fedate,
            "page": this.pagination.currentPage,
            "pageSize": this.pagination.pageSize,
            "sort": "createTime",
            "order": "desc",
            "deviceId": this.deviceChildId
          }
          this.request.get("/front/device/gateway/child/history/page", this.params).then(res => {
            this.consShow=true
            if (res.code == 200) {
              // console.log(res);
              this.tableLoading = false
              this.dataList = res.data.data;
              this.pagination.total = res.data.totalCount;
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
              // this.msg.warn("查询月份的报警分表不存在")
            }
          }).catch(error => {
            console.log(error)
          })
        }
      } else {
        // this.msg.warn("请选择开始日期和结束日期！")
        this.params = {
          "key": this.searchText,
          "startTime": '',
          "endTime": '',
          "page": this.pagination.currentPage,
          "pageSize": this.pagination.pageSize,
          "sort": "createTime",
          "order": "desc",
          "deviceId": this.deviceChildId
        }
        this.request.get("/front/device/gateway/child/history/page", this.params).then(res => {
          this.consShow=true
          if (res.code == 200) {
            this.tableLoading = false
            this.dataList = res.data.data;
            this.pagination.total = res.data.totalCount;
          } else if (res.code == 500) {
            // this.msg.warn("查询月份的报警分表不存在")
            this.msg.warn(res.msg)
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    reloadTable() {
      this.getCurrentYear()
    },
    formatDate(d) {
      let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      let times = d.getFullYear() + "-" + month + "-" + day + " " + hours + ":" + min + ":" + sec;
      return times;
    },
    formatterDate(date) {
      let result = new Date(date);
      return result;
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 550) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight1(height = 530) {
      let _this = this;
      _this.styleObject1.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject1.height = window.innerHeight - height + "px";
        })();
      };
    },
    draw() {
      this.chart = this.$refs.chartLine.chart
      this.chart.setOption(this.options)
    },
    // 历史曲线
    getHositoryEchart(){
      this.chartLoading = true
      let params = {
        quickTime: this.quickTime,
        date:this.echartsTime?this.echartsTime:'',
        deviceId: this.deviceChildId
      }
      this.request.get('/front/device/gateway/child/history', params).then(res => {
        // console.log(res);
        this.chartLoading = false
        if (res.code === 200) {
          if (res.data) {
            this.dataChartsList = [...res.data]
            if(this.dataList.length==0){
              this.options.xAxis[0].data = []
              this.options.series[0].data = []
              this.options.graphic[0].children[0].style.text = ['没有找到您要查询的相关数据']
            }else{
              const xData = []
              const yData = []
              this.dataChartsList.forEach(item => {
                xData.push(item.date)
                yData.push(item.value)
              })
              this.options.xAxis[0].data = xData
              this.options.series[0].data = yData
              // this.options.series[0].name=this.deviceDatas.name+'('+this.deviceDatas.unit+'):'
              this.options.series[0].name=this.deviceDatas.name+':'
              this.options.graphic[0].children[0].style.text = ['']
            }
          } else {
            this.options.xAxis[0].data = []
            this.options.series[0].data = []
            this.options.graphic[0].children[0].style.text = ['没有找到您要查询的相关数据']
          }
        } else if (res.code === 500) {
          this.msg.warn(res.msg)
          this.dataChartsList = []
          this.options.xAxis[0].data = []
          this.options.series[0].data = []
          this.options.graphic[0].children[0].style.text = ['没有找到您要查询的相关数据']
        }
        this.draw()
      })
      .catch(error => {
        console.log(error)
      })
    },
    getHository(data,index){
      this.echartsTime=''
      this.echartsIndex= index
      this.quickTime = data.value
      this.getHositoryEchart()
    },
    searchDataeCharts(){
      if(!this.echartsTime){
        this.msg.warn('请您选择日期！')
        return
      }
      this.quickTime = ''
      this.echartsIndex='no'
      this.echartsTime = this.timeInit.getYMD(this.echartsTime)
      this.getHositoryEchart()
    },
    updateData(){
      if(!(this.datailsData&&this.datailsData.length)){
        return
      }
      if(!this.changeFlag){
        this.$confirm('此操作将开启实时更新, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          clearInterval(this.timer);
          this.timer = null;
          this.changeFlag = true
          this.setIntervalTime()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        })
      } else {
        this.$confirm('此操作将关闭实时更新, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          clearInterval(this.timer);
          this.timer = null;
          this.changeFlag = false
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        })
      }
    },
    setIntervalTime() {
      let that = this
      that.timer = setInterval(() => {
        setTimeout(() => {
          ///调取接口获取数据
          that.detailDatas()
          console.log(222)
        }, 0)
      }, 5000);
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  deactivated() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  beforeRouteLeave(to, from, next) {
    next();
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}
</script>

<style lang="scss" scoped>
.DeviceDatasContainer {
  width: 100%;
  height: 100%;

  .commonCons {
    width: 100%;

    .cons {
      width: 100%;
      height: 36px;
      background: #F4F7FA;
      border-radius: 2px;
      position: relative;
      h3 {
        width: 100%;
        line-height: 36px;
        text-align: center;
        font-size: 14px;
        font-family: AlibabaPuHuiTi-Medium;
        font-weight: 500;
        color: #33383E;
      }
      .rightUpdate{
        position: absolute;
        top: 0;
        right: 0;
        height: 36px;
        overflow: hidden;
        z-index: 10;
        background: #1089FF;
        padding: 0 10px;
        cursor: pointer;
        border-radius: 3px;
        i{
          float: left;
          width: 16px;
          height: 16px;
          margin-right: 5px;
          margin-top: 6px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        b{
          float: left;
          font-size: 14px;
          font-weight: 500;
          font-family: AlibabaPuHuiTi-Medium;
          color: #FFFFFF;
          line-height: 36px;
        }
      }
    }
    .tabChangs{
      margin: 10px 0 15px;
      width: 100%;
      box-sizing: border-box;
      height: 30px;
      line-height: 30px;
      border-bottom: 1px #EAEBEB solid;
      ul{
        overflow: hidden;
        li{
          float: left;
          font-size: 14px;
          font-family: AlibabaPuHuiTi-Medium;
          font-weight: 500;
          color: #7A7D81;
          box-sizing: border-box;
          margin-right: 40px;
          cursor: pointer;
          &.active{
            height: 29px;
            color: #1089FF;
            border-bottom: 2px solid #1089FF;
          }
          &:hover{
            color: #1089FF;
          }
        }
      }
    }
    .listCons{
      .query{
        overflow: hidden;
        .qCons{
          float: left;
        }
        .qTit{
          float: right;
          overflow: hidden;
          i{
            float: left;
            width: 14px;
            height: 14px;
            margin-top: 6px;
            img{
              width: 100%;
              height: 100%;
              vertical-align: top;
            }
          }
          b{
            padding: 0 10px;
            float: left;
            font-size: 14px;
            font-family: AlibabaPuHuiTi-Medium;
            font-weight: 500;
            color: #1089FF;
            line-height: 26px;
            height: 26px;
            background: linear-gradient(149deg, rgba(16, 137, 255, 0) 0%, rgba(16, 137, 255, 0.2) 100%);
          }
        }
        .primaryBtn{
          width: 82px;
          height: 36px;
          cursor: pointer;
          margin-right: 20px;
          font-size: 14px;
          font-family: AlibabaPuHuiTi-Medium;
          line-height: 36px;
          border: 0;
          color: #FFFFFF;
          background: #1089FF;
          border-radius: 2px;
          &:hover{
            background: #0774e0;
          }
        }
      }
      .dataCons{
        position: relative;
        .noData{
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -150px;
          margin-top: -150px;
          text-align: center;
          img{
            width: 300px;
            height: 300px;
          }
          .tip{
            margin-top: 10px;
            font-size: 18px;
            color: #bbb;
          }
        }
      }
    }
    .echartsShow{
      width: 100%;
      // height: 100%;
      font-size: 0;
      .queryLists{
        overflow: hidden;
        height: 36px;
        .left{
          float: left;
        }
        .right{
          height: 100%;
          float: right;
          ul{
            height: 100%;
            overflow: hidden;
            li{
              height: 100%;
              float: left;
              margin-left: 10px;
              span{
                display: inline-block;
                width: 68px;
                line-height: 36px;
                height: 100%;
                font-size: 14px;
                font-weight: 500;
                color: #7A7D81;
                text-align: center;
                box-shadow: 0px 0px 8px #E6E6E6 inset; //四周阴影
                cursor: pointer;
                border-radius: 3px;
              }
              &.active{
                span{
                  box-shadow: 0px 0px 8px #2177E6 inset; //四周阴影
                  color: #2177E6;
                }
              }
            }
          }
        }
      }
    }
  }

  .nowData {}

  .hositoryData {}

  .cardBanner {
    padding: 10px 30px;
    background-color: #fff;
    position: relative;
    height: 110px;
    position: relative;
    .noData{
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -28px;
      margin-top: -7px;
      span{
        font-size: 14px;
        line-height: 14px;
        color: #ccc;
      }
    }
    .cardTit{
      overflow: hidden;
      a{
        font-family: AlibabaPuHuiTi-Medium;
        .p1{
          margin-top: 15px;
          font-size: 14px;
          font-weight: 500;
          color: #1089FF;
          text-align: left;
          box-sizing: border-box;
          padding-left: 30px;
        }
        .p2{
          font-size: 42px;
          font-weight: bold;
          font-family: GoogleSans-Bold;
          color: #1089FF;
        }
      }
    }
  }
}
</style><style lang="scss">
.DeviceDatasContainer {
  .query {
    padding-bottom: 15px;

    .el-input {
      width: 380px;
      margin-right: 10px;

      .el-input__inner {
        line-height: 36px;
        height: 36px;
      }
    }

    .el-select {
      width: 180px;
      margin-right: 10px;

      .el-input {
        width: 180px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }
    }

    .el-range-editor.el-input__inner {
      height: 36px;
      line-height: 36px;
      padding: 5px 10px;
      margin-right: 10px;
    }
    .el-date-editor{
      .el-input__prefix{
        .el-input__icon{
          line-height: 36px;
        }
      }
      .el-input__suffix{
        .el-input__icon{
          line-height: 36px;
        }
      }
    }
  }
  .queryLists{
    .query{
      .el-date-editor{
        width: 150px;
      }
    }
  }

  .el-carousel{
    width: 700px;
    padding-left: 100px;
    margin: 0 auto;
    .el-carousel__item{
      background: url('../../../assets/img/deviceGas/nowDataBg.png') no-repeat;
      background-size: 100% 100%;
      opacity: 0.6;
      &.active{
        opacity: 1;
      }
    }
  }

  // .el-carousel__item:nth-child(2n) {
  //   // background-color: #99a9bf;
  //   background: url('../../../assets/img/deviceGas/nowDataBg.png') no-repeat;
  //   background-size: 100% 100%;
  // }

  // .el-carousel__item:nth-child(2n+1) {
  //   background: url('../../../assets/img/deviceGas/nowDataBg.png') no-repeat;
  //   background-size: 100% 100%;
  //   // background-color: #d3dce6;
  // }

  .el-carousel__item.el-carousel__item--card.is-in-stage {
    width: 200px;
    height: 110px;
    text-align: center;
  }

  /*修改高度*/
  .el-carousel__container {
    height: 110px;
  }
  .el-carousel__indicators{
    display: none;
  }
  .van-collapse-item__content {
    padding: 14px 0;
  }

  /*左右箭头的样式*/
  button.el-carousel__arrow.el-carousel__arrow--left,
  button.el-carousel__arrow.el-carousel__arrow--right {
    font-size: 14px;
    height: 30px;
    width: 30px;
    background: #A099F0;
    display: none;
  }
}
</style>
